import { FontSize, Footer, Logo, RegularTextS, Space } from "@enxcs/dap-ui-stratos";
import styled from "styled-components";

export const CustomFooter = styled(Footer)`
  align-items: center !important;
  display: flex;
  gap: ${Space.V4};
  justify-content: space-between;
  min-width: 0;
  height: 39px;
  max-height: 39px;
`;

export const CustomLogo = styled(Logo)`
  cursor: pointer;
`;

export const CustomVersionInfo = styled(RegularTextS)`
  font-size: ${FontSize.V12};
`;
